import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import removeAllHandlesOnSelectedFrame from 'rangeConfig/shared/behaviors/removeAllHandlesOnSelectedFrame';

const addHandlesToFrontsOnSelectedFrame = ({
  coreApi,
  props,
  dispatch,
  rootState
}: BehaviorParameters) => {
  const frame = props.position
    ? coreApi.entities.getEntityClosestToPosition(props.position, [ComponentIds.FRAME_COMPONENT_ID])
    : coreApi.entities.findSelectedEntity();

  if (frame) {
    removeAllHandlesOnSelectedFrame({ coreApi, props, dispatch, rootState });
    const fronts = coreApi.entities
      .getFrameDescendants(frame)
      .filter(
        child =>
          child.hasComponent(ComponentIds.DOOR_COMPONENT_ID) ||
          child.hasComponent(ComponentIds.DRAWER_COMPONENT_ID)
      );
    coreApi.products.autoFillHandles(props.coreProductId, [], fronts);
  }
};

export default addHandlesToFrontsOnSelectedFrame;
